import "bootstrap/dist/css/bootstrap.min.css";
import toast from "react-hot-toast";
import axios from "axios";
import React, { useContext, useRef, useState, useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";
import { AuthContext } from "../../context/Authcontext";

const base_url = process.env.REACT_APP_API_URL;

const Racing = () => {
  const [games, setGames] = useState([]);
  const [token, setToken] = useState();
  const [filteredGames, setFilteredGames] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchTimeoutRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(36); // Show 36 initially
  const { themeColors } = useTheme();
  const { isAuthenticated } = useContext(AuthContext);
  const isSmallScreen = window.innerWidth < 768;

  const casinoGames = async () => {
    try {
      const eventSource = new EventSource(base_url + "/api/valid/token", {
        withCredentials: true,
      });

      console.log("EventSource initialized for casino games.");

      let receivedGames = [];

      eventSource.addEventListener("message", (event) => {
        const data = JSON.parse(event.data);

        if (data.token) setToken(data.token);
        if (data.chunk && Array.isArray(data.chunk)) {
          receivedGames = [...receivedGames, ...data.chunk];
          setGames(receivedGames);
        }
        if (data.complete || data.error) eventSource.close();
      });

      eventSource.onerror = (error) => {
        console.error("EventSource error:", error);
        eventSource.close();
      };
    } catch (err) {
      console.error("Error in casinogames function:", err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    casinoGames();
  }, []);

  useEffect(() => {
    setFilteredGames(games);
  }, [games]);

  // Search logic
  useEffect(() => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    if (!searchText.trim()) {
      setFilteredGames(games);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      const lowerCaseSearch = searchText.toLowerCase();
      const filtered = games.filter((game) => {
        if (!game) return false;
        return (
          game.name?.toLowerCase().includes(lowerCaseSearch) ||
          game.provider?.name?.toLowerCase().includes(lowerCaseSearch)
        );
      });

      setFilteredGames(filtered);
      setIsSearching(false);
    }, 300);

    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    };
  }, [searchText, games]);

  const openGameById = async (gameId) => {
    try {
      const response = await axios.post(
        base_url + "/api/gamelaunch/url",
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        },
      );

      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error("Please Login to play!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Unable to launch game. Please try again.");
    }
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop: "12px",
        padding: "0px 0px 10px",
        boxSizing: "border-box",
      }}
    >
      {/* --- Search Bar --- */}
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ flexWrap: "wrap" }}
      >
        <h5 className="text-black"> All Casino Games</h5>
        <input
          type="text"
          placeholder="Search games..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="form-control"
          style={{
            maxWidth: "230px",
            borderRadius: "6px",
            fontSize: "10px",
          }}
        />
        {/* <div
          style={{
            fontSize: '14px',
            color: '#666',
            marginTop: '5px',
          }}
        >
          {isSearching
            ? 'Searching...'
            : `Showing ${Math.min(visibleCount, filteredGames.length)} of ${
                filteredGames.length
              } games`}
        </div> */}
      </div>

      {/* --- Games Grid --- */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.innerWidth < 576 ? "repeat(3, 1fr)" : window.innerWidth < 1000 ? "repeat(6, 1fr)" : "repeat(10, 1fr)",
          gap: "4px",
        }}
      >
        {filteredGames.slice(0, visibleCount).map((game, idx) => (
          <div
            key={idx}
            style={{
              // maxWidth: 'calc(16.66% - 4px)',
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                backgroundImage: `url(${game?.images?.[2]?.url || game?.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: window.innerWidth < 576 ? "100px" : "130px",
                borderRadius: "0px",
                position: "relative",
                cursor: "pointer",
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                width: "100%",
              }}
              onClick={() => openGameById(game.id || game.gameId)}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  width: "100%",
                  background: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  fontSize: "11px",
                  padding: "2px 0",
                  textAlign: "center",
                }}
              >
                {/* {game.name} */}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* --- Load More Button --- */}
      {visibleCount < filteredGames.length && (
        <div className="text-end mt-3">
          <button
            className="btn btn-primary btn-sm"
            onClick={() => setVisibleCount((prev) => prev + 36)}
          >
            More Games →
          </button>
        </div>
      )}
    </div>
  );
};

export default Racing;
